import DataLayerManager from "../trackers/dataLayer/dataLayerManager";
import FeaturedMenuFilter from "./featuredMenuFilter";
import RangeGraphInput from "@web/vpt-assets/assets/js/modules/rangeGraphInput";

export const filterAvailableOptions = ['thematic', 'featureddates', 'allowpets', 'mealplan', 'accommodationcategory', 'accommodationtype', 'rating', 'price', 'freecancellation', 'location', 'whentravel', 'featuredmenu'];

export default class GroupsFilters {
    constructor() {
        this.filtersContainer = $('[data-container="filters"]');
        if (this.filtersContainer.length === 0) return;

        this.numBars = 20;
        this.dataLayerManager = new DataLayerManager();
        this.groupList = [];
        this.tagsDisplayedLimit = 6;
        this.filtersApplied = {
            'thematic': [],
            'featureddates': [],
            'allowpets': [],
            'mealplan': [],
            'accommodationcategory': [],
            'accommodationtype': [],
            'rating': [],
            'price': [],
            'freecancellation': [],
            'location': [],
            'whentravel': [],
            'featuredmenu': []
        };
        this.filterAvailableOptions = filterAvailableOptions;
        this.filtersWithORCondition = ['accommodationcategory', 'accommodationtype', 'mealplan', 'featureddates', 'rating', 'price', 'location', 'whentravel'];
        this.tagList = {
            'thematic': [],
            'featureddates': [],
            'allowpets': [],
            'mealplan': [],
            'accommodationcategory': [],
            'accommodationtype': [],
            'rating': [],
            'price': [],
            'freecancellation': [],
            'location': [],
            'whentravel': []
        };

        this.filterToGroupMap = new Map();
        this.priceRange = new Map();
        if (myApp.relationFiltersGroupsIds) {
            myApp.relationFiltersGroupsIds.forEach(item => {
                const key = `${item.filterType}-${item.filterId}`;
                if (this.filterToGroupMap.has(key)) {
                    this.filterToGroupMap.set(key, new Set([...this.filterToGroupMap.get(key), ...item.groupsIds]));
                } else {
                    this.filterToGroupMap.set(key, new Set(item.groupsIds));
                }
                if (item.filterType === 'price') {
                    const fid = Number(item.filterId);
                    if (this.priceRange.has(key)) {
                        this.priceRange.set(fid, new Set([...this.priceRange.get(key), ...item.groupsIds]));
                    } else {
                        this.priceRange.set(fid, new Set(item.groupsIds));
                    }
                }
            });

            if (this.priceRange.size > 0) {
                this.priceRange = new Map([...this.priceRange].sort((a, b) => a[0] - b[0]));
            }
        }

        if (myApp.priceRangeGraph && myApp.priceRangeGraph.length > 0) {
            this.priceRangeMin = myApp.priceRangeGraph[0].data.min;
            this.priceRangeMax = myApp.priceRangeGraph[myApp.priceRangeGraph.length - 1].data.max;
        }

        this.initializePriceFilterGraph();
        this.filtersAppliedModule = document.querySelector('[data-entity="filter-applied-module"]');
        this.filtersAppliedContainer = document.querySelector('[data-entity="filter-applied"]');
        this.filtersAppliedMobileModule = document.querySelector('[data-entity="filters-applied-mobile-module"]');
        this.filtersAppliedMobileContainer = document.querySelector('[data-entity="filters-applied-mobile"]');
        this.isMobileView = false;
        this.removeItem = this.createRemoveItem();
        this.initialize();
        new FeaturedMenuFilter(this);
    }

    initialize() {
        this.calculateCollapseHeight();
        this.setUserFilters();
        if (this.checkAnyFiltersApplied()) {
            this.doFilter();
        } else {
            this.printGroups();
        }
        this.eventDelegation();
        this.initializeWithGetParams();
        if (['xs', 'sm'].includes(myApp.deviceDetector.deviceSize)) {
            this.isMobileView = true;
            this.moveAppliedFilters();
        }
    };

    eventDelegation() {
        this.filtersContainer.on("click", '[data-action="filter"]', (event) => {
            let currentElement = $(event.currentTarget);
            if (currentElement.attr('data-entity') === 'applied-filter') {
                const filterName = currentElement.attr('name');
                this.removeAppliedFilter(currentElement[0]);
                const filter = document.querySelector('[name=' + filterName + ']:not([data-entity=applied-filter])');
                filter.click();
                return;
            }

            const isChecked = currentElement.is(':checked');

            if (currentElement.hasClass('label-disabled')) {
                return false;
            }

            if (currentElement.data('field') === 'groups-counter') {
                currentElement = currentElement.prev().find("[data-filter-type]");
                currentElement.prop('checked', !isChecked);
            }
            this.refreshGetParams(currentElement);
            this.sendFilterToDatalayer(currentElement);

            if (isChecked) {
                this.showAppliedFilter(currentElement[0]);
            } else {
                this.removeAppliedFilter(currentElement[0]);
            }
            this.doFilter();
        });

        const body = $('body');
        body.on("click", '[data-action="reset-filters"], [data-action="restore-filters"]', () => {
            this.restoreFilters();
        });

        $('[data-open="filters"]').on('click', (e) => {
            e.stopPropagation();
            this.filtersContainer.addClass('show');
            body.addClass('filters-opened');
        });

        $('[data-close="filters"]').on('click', () => {
            this.filtersContainer.removeClass('show');
            body.removeClass('filters-opened');
        });

        window.addEventListener('resize', () => {
            if (!this.isMobileView && ['xs', 'sm'].includes(myApp.deviceDetector.deviceSize)) {
                this.isMobileView = true;
                this.moveAppliedFilters();
                return;
            }
            if (this.isMobileView && !['xs', 'sm'].includes(myApp.deviceDetector.deviceSize)) {
                this.isMobileView = false;
                this.moveAppliedFilters(false);
            }
        });
    };

    sendFilterToDatalayer(elementContainer) {
        const translated = elementContainer.data('filter-name-translated');
        const filterName = translated != null ? translated : elementContainer.data('filter-name');

        let data = {
            event: "filter_interaction",
            event_category: "filter",
            event_detail_1: elementContainer.data('filter-type'),
            event_detail_2: filterName,
            event_detail_3: elementContainer.is(':checked') ? 'check' : 'uncheck'
        };

        this.dataLayerManager.pushData(JSON.stringify(data));
    }

    doFilter(priceFilter = false) {
        this.setUserFilters();
        this.setUserPriceFilter();
        this.printGroups('price');
        let allGroups = [];
        if (!priceFilter) {
            allGroups = document.querySelectorAll('[data-entity="group"]:not([style*="display: none"])');
        }
        const checkFilterPrice = this.filtersApplied['price'].length > 0;
        if (checkFilterPrice) {
            this.printGroups();
        }

        this.updateAvailableOptions();
        this.applyFilters();
        if (!priceFilter) {
            this.updatePriceGraph(allGroups);
        }
    }

    applyFilters() {
        this.updateFiltersCounterText();
        this.manageCollapseFilters();
        this.manageComingSoonMessageVisibility();
        myApp.book.availabilityManager.reorderBanners();
        this._scrollToElement();
        const filterOverlay = $('#filter_overlay');
        if (filterOverlay.is(':visible')) {
            filterOverlay.fadeOut(1000);
        }
    }

    initializeFilters() {
        document.querySelectorAll('[data-entity="group"]').forEach(group => {
            group.style.display = '';
        });
    }

    manageCollapseFilters() {
        this.calculateCollapseHeight();
        const collapseToggles = document.querySelectorAll('.filter_content [data-action="toggle-collapse"]');

        collapseToggles.forEach(toggle => {
            const targetSelector = toggle.getAttribute("data-target");
            const targetElement = document.querySelector(targetSelector);
            const minHeight = parseInt(targetElement.style.minHeight)
            if (minHeight >= 200) {
                toggle.style.display = "flex";
            } else if (minHeight < 200) {
                toggle.style.display = "none";
            }
        });
    }

    setUserFilters() {
        $("[data-filter-type]").each((_, checkboxElement) => {
            const checkbox = $(checkboxElement);
            const filterType = checkbox.data('filter-type');
            const filterId = checkbox.data('id');

            if (checkbox.is(':checked') && !this.filtersApplied[filterType].includes(filterId)) {
                this.filtersApplied[filterType].push(filterId);
            } else if (!checkbox.is(':checked') && this.filtersApplied[filterType].includes(filterId)) {
                this.filtersApplied[filterType] = this.filtersApplied[filterType].filter(id => id !== filterId);
            }
        });
    }

    setUserPriceFilter() {
        if (!myApp.priceRangeGraph || myApp.priceRangeGraph.length === 0) return;
        if (!this.rangeGraph || this.priceRange.size === 0) {
            this.filtersApplied['price'] = [];
            return;
        }

        let minValue = Number(this.rangeGraph.sliderStart.value);
        let maxValue = Number(this.rangeGraph.sliderEnd.value);

        if (minValue === this.priceRangeMin && maxValue === this.priceRangeMax) {
            this.filtersApplied['price'] = [];
            return;
        }

        const selectedPrices = [];
        for (const [price, _groupIds] of this.priceRange) {
            if (price < minValue) continue;
            if (price > maxValue) break;
            selectedPrices.push(price);
        }

        if (selectedPrices.length === 0 && (this.rangeGraph.startInputModified || this.rangeGraph.endInputInputModified)) {
            selectedPrices.push(-1);
        }

        this.filtersApplied['price'] = selectedPrices;
    }

    manageComingSoonMessageVisibility() {
        const comingSoonModule = $('[data-entity="comingSoonModule"]');

        let isVisibleOnSaleSection = false;
        const isVisibleFeaturedSection = $('[data-category="featured"]').is(':visible');
        const isVisibleUserExclusiveSection = $('[data-category="user_exclusive"]').is(':visible');
        const isVisibleComingSoonSection = $('[data-category="coming_soon"]').is(':visible');
        const groupSection24h = $('[data-category="on_sale"][data-category-id="on_sale_24"]');
        const hasVisibleGroup24h = groupSection24h.find('[data-entity="group"]').is(":visible");

        $.each($('[data-category="on_sale"]'), (i, category) => {
            if ($(category).is(":visible")) {
                isVisibleOnSaleSection = true;
            }
        });

        groupSection24h.toggle(hasVisibleGroup24h);

        if ((isVisibleOnSaleSection || isVisibleFeaturedSection || isVisibleUserExclusiveSection) && isVisibleComingSoonSection) {
            comingSoonModule.show();
        } else {
            comingSoonModule.hide();
        }
    }

    updateFiltersCounterText() {
        const allGroups = document.querySelectorAll('[data-entity="group"]');
        const visibleGroups = Array.from(allGroups).filter(group => group.style.display !== 'none').length;
        const countTotalGroups = allGroups.length;

        const filterTitleContainer = document.querySelector('[data-container="filter-title"]');
        const filterButtonContainer = document.querySelector('[data-container="filter-button"]');
        const resetFilters = document.querySelector('[data-container="reset-filters-lg"]');
        const resetFiltersXs = document.querySelector('[data-container="filter-reset-xs"]');
        const filterCount = document.querySelector('[data-name="filter-count"]');
        const defaultFilterTitle = document.querySelector('[data-container="default-filter-title"]');
        const hideOnSortElements = document.querySelectorAll("[data-hide-on-sort]");

        if (resetFiltersXs) {
            if (countTotalGroups === visibleGroups) {
                resetFiltersXs.classList.remove('active');
            } else {
                resetFiltersXs.classList.add('active');
            }
        }


        const updateFilterButton = (template, count) => {
            if (template) {
                filterButtonContainer.innerHTML = template.replace("%currentCount%", count);
            }
        };

        const updateFilterTitle = (template, validatedCount, totalCount) => {
            if (template) {
                filterTitleContainer.innerHTML = template
                    .replace("%currentCount%", validatedCount)
                    .replace("%totalCount%", totalCount);
                defaultFilterTitle.style.display = 'none';
            }
        };

        if (this.checkAnyFiltersApplied()) {
            const filterTitleTextResult = filterTitleContainer.dataset.templateText;
            const filterButtonApply = filterButtonContainer.dataset.templateText;
            const filterButtonApplyOneResult = filterButtonContainer.dataset.templateTextOneResult;

            updateFilterButton(visibleGroups > 1 ? filterButtonApply : filterButtonApplyOneResult, visibleGroups);
            updateFilterTitle(filterTitleTextResult, visibleGroups, countTotalGroups);
            filterTitleContainer.style.display = visibleGroups >= 1 ? '' : 'd-none';
        } else {
            defaultFilterTitle.style.display = '';
            filterTitleContainer.style.display = 'none';
        }

        if (this.checkRestoreFiltersButtonVisibility() || myApp.book.availabilitySorter.checkActiveSorter()) {
            if (this.checkRestoreFiltersButtonVisibility()) {
                resetFilters.style.display = '';
            } else {
                resetFilters.style.display = 'none';
            }

            if (myApp.book.availabilitySorter.checkActiveSorter()) {
                filterCount.style.display = '';
            } else {
                filterCount.style.display = 'none';
            }
            document.querySelectorAll('[data-action="restore-filters"]').forEach(el => el.style.display = '');
            hideOnSortElements.forEach(el => el.style.display = 'none');
        } else {
            resetFilters.style.display = 'none';
            filterCount.style.display = 'none';
            updateFilterButton(filterButtonContainer.dataset.templateText, countTotalGroups);
            hideOnSortElements.forEach(el => el.style.display = '');
        }
    }

    checkAnyFiltersApplied() {
        return Object.values(this.filtersApplied).some(filter => filter.length > 0);
    }

    // Don´t need to check featured menu because is not really a filter.
    checkRestoreFiltersButtonVisibility() {
        return Object.entries(this.filtersApplied).filter(([key]) => key !== 'featuredmenu').some(([, arr]) => arr.length > 0);
    }

    updateAvailableOptions() {
        let currentVisibleGroupIds = new Set();
        const appliedFilters = Object.entries(this.filtersApplied)
            .filter(([, values]) => values.length > 0);

        if (appliedFilters.length === 0) {
            const allGroupIds = new Set();
            this.filterToGroupMap.forEach(groupSet => {
                groupSet.forEach(id => allGroupIds.add(id));
            });
            currentVisibleGroupIds = allGroupIds;
            this._filterResultsModuleVisibility(false)
        } else {
            const groupSets = [];
            for (const [key, values] of appliedFilters) {
                const useOR = this.filtersWithORCondition.includes(key);
                const groupIds = this._findGroupsIds(key, values, useOR);
                if (groupIds.length > 0) {
                    groupSets.push(new Set(groupIds));
                } else if (!useOR) {
                    groupSets.push(new Set());
                }
            }

            if (groupSets.length > 0) {
                currentVisibleGroupIds = groupSets[0];
                for (let i = 1; i < groupSets.length; i++) {
                    currentVisibleGroupIds = new Set([...currentVisibleGroupIds].filter(id => groupSets[i].has(id)));
                }
                currentVisibleGroupIds.size > 0 ? this._filterResultsModuleVisibility(false) : this._filterResultsModuleVisibility(true);
            }
        }

        document.querySelectorAll('[data-action="filter"][data-filter-type]').forEach(checkbox => {
            const label = checkbox.closest('label');
            if (!label) return;
            const counterElement = label.querySelector('.filter-option-count');
            if (!counterElement) return;

            const filterType = checkbox.dataset.filterType;
            const filterId = checkbox.dataset.id;
            const key = `${filterType}-${filterId}`;
            const optionGroupIds = this.filterToGroupMap.get(key) || new Set();

            let updateDisabled = false;
            if (
                (Object.entries(this.filtersApplied).filter(([, values]) => values.length > 0).length === 1 &&
                    this.filtersApplied[filterType].length > 0)
                || key === 'featuredmenu') {

                if (label.classList.contains('disabled')) {
                    label.classList.remove('disabled');
                }
                updateDisabled = true;
            }

            let count = 0;

            if (this.filtersWithORCondition.includes(filterType)) {
                let otherFilters = Object.entries(this.filtersApplied)
                    .filter(([ft, vals]) => vals.length > 0 && ft !== filterType);

                let baseSet;
                if (otherFilters.length === 0) {
                    baseSet = new Set();
                    this.filterToGroupMap.forEach(ids => ids.forEach(id => baseSet.add(id)));
                } else {
                    const sets = [];
                    for (const [ft, vals] of otherFilters) {
                        const useOR = this.filtersWithORCondition.includes(ft);
                        const ids = this._findGroupsIds(ft, vals, useOR);
                        sets.push(new Set(ids));
                    }
                    baseSet = sets[0];
                    for (let i = 1; i < sets.length; i++) {
                        baseSet = new Set([...baseSet].filter(id => sets[i].has(id)));
                    }
                }

                const finalSet = new Set([...baseSet].filter(id => optionGroupIds.has(id)));
                count = finalSet.size;
            } else {
                const intersection = new Set([...currentVisibleGroupIds].filter(id => optionGroupIds.has(id)));
                count = intersection.size;
            }

            if (count > 0) {
                counterElement.innerHTML = `(${count})`;
            }

            if (checkbox.checked) {
                label.classList.remove('disabled');
                return;
            }

            if (updateDisabled) return;

            if (count === 0) {
                label.classList.add('disabled');
            } else {
                label.classList.remove('disabled');
            }
        });
    }

    printGroups(avoidFilter = null) {
        const allGroupElements = document.querySelectorAll('[data-entity="group"]');
        const allGroupLists = document.querySelectorAll('[data-container-list="groups"] [data-category], [data-container="groups-sorted"]');
        let visibleIds = new Set();

        if (!this.filterToGroupMap || !this.checkAnyFiltersApplied()) {
            allGroupElements.forEach(group => group.style.display = '');
            allGroupLists.forEach(list => list.style.display = '');
            this._filterResultsModuleVisibility(false);
            this.updateAvailableOptions();
            return;
        }

        const appliedFilters = Object.entries(this.filtersApplied)
            .filter(([key, values]) => values.length > 0 && (avoidFilter == null || key !== avoidFilter));

        if (appliedFilters.length === 0) {
            allGroupElements.forEach(group => group.style.display = '');
            allGroupLists.forEach(list => list.style.display = '');
            this.updateAvailableOptions();
            return;
        }

        const groupSets = [];
        for (const [key, values] of appliedFilters) {
            const useOR = this.filtersWithORCondition.includes(key);
            const groupIds = this._findGroupsIds(key, values, useOR);
            if (groupIds.length === 0 && !useOR) {
                this._hideAllGroups(allGroupElements, allGroupLists);
                this.updateAvailableOptions();
                return;
            }
            if (groupIds.length > 0) {
                groupSets.push(new Set(groupIds));
            }
        }

        if (groupSets.length === 0) {
            this._hideAllGroups(allGroupElements, allGroupLists);
            this.updateAvailableOptions();
            return;
        }

        let finalSet = groupSets[0];
        for (let i = 1; i < groupSets.length; i++) {
            const nextSet = groupSets[i];
            finalSet = new Set([...finalSet].filter(id => nextSet.has(id)));
            if (finalSet.size === 0) {
                this._hideAllGroups(allGroupElements, allGroupLists);
                this.updateAvailableOptions();
                return;
            }
        }

        visibleIds = finalSet;
        const groupMap = new Map();

        const filterPriceMap = new Map();
        const filterPriceRangeMap = this.priceRange;
        if (myApp.book.additionalMealPlansByChollo) {
            for (let key of this.filterToGroupMap.keys()) {
                if (key.toLowerCase().includes("price")) {
                    filterPriceMap.set(key, new Set(this.filterToGroupMap.get(key)));
                    this.filterToGroupMap.delete(key);
                }
            }
            this.priceRange = new Map();
        }

        allGroupElements.forEach(group => {
            const id = group.getAttribute('data-id');
            const isVisible = visibleIds.has(+id);

            group.style.display = isVisible ? '' : 'none';

            if (myApp.book.additionalMealPlansByChollo) {
                this._filterByMealplan(group);
            }

            if (isVisible) {
                const parent = group.closest("[data-category]");
                if (parent) {
                    const cat = parent.getAttribute('data-category');
                    if (!groupMap.has(cat)) groupMap.set(cat, []);
                    groupMap.get(cat).push(group);
                }
            }
        });

        let hasPriceUpdate = false;
        for (let key of this.filterToGroupMap.keys()) {
            if (key.toLowerCase().includes("price")) {
                hasPriceUpdate = true;
                break;
            }
        }

        if (!hasPriceUpdate && filterPriceMap) {
            this.filterToGroupMap = new Map([...this.filterToGroupMap, ...filterPriceMap]);
            this.priceRange = filterPriceRangeMap;
        }

        allGroupLists.forEach(list => {
            const cat = list.getAttribute('data-category');
            if (!cat) {
                list.style.display = '';
                return;
            }
            list.style.display = groupMap.has(cat) ? '' : 'none';
        });
    }

    _hideAllGroups(groupElements, groupLists) {
        groupElements.forEach(g => g.style.display = 'none');
        groupLists.forEach(l => l.style.display = 'none');
    }

    restoreFilters() {
        this.restoreFilterCheckboxes();
        this.restoreFilterByPrice();
        this.removeAllAppliedFilters();
        this.initializeFilters();
        this.doFilter();
        this.restoreFilterParams();
        this._scrollToElement();
    }

    restoreFilterByPrice() {
        if (!myApp.priceRangeGraph || myApp.priceRangeGraph.length === 0) return;

        this.rangeGraph.sliderStart.min = this.priceRangeMin;
        this.rangeGraph.sliderStart.max = this.priceRangeMax;
        this.rangeGraph.sliderStart.value = this.priceRangeMin;

        this.rangeGraph.sliderEnd.min = this.priceRangeMin;
        this.rangeGraph.sliderEnd.max = this.priceRangeMax;
        this.rangeGraph.sliderEnd.value = this.priceRangeMax;

        this.rangeGraph.startInputModified = false;
        this.rangeGraph.endInputInputModified = false;

        this.rangeGraph._formatInput(this.rangeGraph.inputStart, this.priceRangeMin);
        this.rangeGraph._formatInput(this.rangeGraph.inputEnd, this.priceRangeMax);

        this.rangeGraph._checkCurrentValues(this.priceRangeMin, this.priceRangeMax);
        this.rangeGraph._generateGraphBars(myApp.priceRangeGraph);
        this.rangeGraph._fillSlider(this.rangeGraph.sliderEnd);
    }

    restoreFilterCheckboxes() {
        $('[data-action="filter"]').prop('checked', false);
        this.filtersContainer.find("[data-filter-type]").closest('.checkbox').removeClass('active');
        if (this.filtersApplied['featuredmenu'].length <= 0) {
            $('[data-container="filter-title"]').hide();
        }
    }

    restoreFilterParams() {
        let getParams = new URLSearchParams(window.location.search);
        const allParams = getParams.keys();
        for (const key of Array.from(allParams)) {
            if (Object.keys(this.tagList).includes(key)) {
                getParams.delete(key);
            }
        }

        window.history.replaceState({}, '', getParams ? ('?' + getParams.toString()) : window.location.pathname);
    }

    restoreSortingParams() {
        let getParams = new URLSearchParams(window.location.search);
        const allParams = getParams.keys();
        for (const key of Array.from(allParams)) {
            if (['sorter', 'sorterOrder'].includes(key)) {
                getParams.delete(key);
            }
        }

        window.history.replaceState({}, '', getParams ? ('?' + getParams.toString()) : window.location.pathname);
    }

    counterFiltersOnFilterCategory(category) {
        if (typeof this.tagList[category] === 'undefined') return;
        return (this.tagList[category].filter(categoryCheckbox => categoryCheckbox['amount'] > 0).length > 8);
    }

    calculateCollapseHeight() {
        const filtersCollapse = $('[name="filter-collapse"]');

        filtersCollapse.each((i, filterCollapse) => {
            let collapseHeight = 0;
            $(filterCollapse).children().each((item, filter) => {
                if (item < this.tagsDisplayedLimit && $(filter).css('display') != 'none') {
                    collapseHeight += $(filter).outerHeight(true);
                }
            });
            $(filterCollapse).css('min-height', Math.round(collapseHeight) + 'px');
        });
    }

    initializeWithGetParams() {
        let validFilter = false;
        $.each(this.filterAvailableOptions, (i, type) => {
            let filterParam = new URLSearchParams(window.location.search)
            for (const [key, value] of filterParam.entries()) {
                if (key == type) {
                    const filterCheckbox = $('[data-filter-type="' + key + '"][data-id="' + value + '"]');
                    if (filterCheckbox.length > 0) {
                        validFilter = true;
                        filterCheckbox.click();
                    }
                }
            }
        });

    }

    refreshGetParams(currentElement) {
        const getParams = new URLSearchParams(window.location.search);
        const filterType = currentElement.parent().find('[data-filter-type]').data('filter-type');
        const filterId = currentElement.parent().find('[data-filter-type]').data('id');

        if (currentElement.is(':checked')) {
            const existingParams = getParams.getAll(filterType);
            if (!existingParams.includes(filterId.toString())) {
                getParams.append(filterType, filterId);
            }
        } else {
            const params = getParams.getAll(filterType).filter(value => value !== filterId.toString());
            getParams.delete(filterType);
            params.forEach(value => getParams.append(filterType, value));
        }

        const newUrl = getParams.toString() ? `?${getParams.toString()}` : window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }

    _scrollToElement() {
        const scrollToElement = document.querySelector('[data-container="default-filter-title"]');
        if (scrollToElement) {
            const offsetTop = scrollToElement.offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    }

    _filterByMealplan(element) {
        const filtersChecked = this.filtersApplied.mealplan;
        const mealPlans = myApp.book.additionalMealPlansByChollo[element.dataset.cholloId];
        const additionalMealPlansContainer = $(element).find('[data-entity="additional-meal-plans"]');
        const groupTitle = $(element).find('.group-title');
        const groupDescription = $(element).find('[data-entity="description"]');
        const groupPrice = $(element).find('.chollo-price');
        const schematicLabels = $(element).find('[data-entity="schematic-labels"]');
        const schematicLabelTemplate = $(schematicLabels.children()[0]).clone(true);
        const groupEntity = myApp.book.availabilityManager.availabilityList.find(g => g.id === +element.dataset.id);

        if (filtersChecked.length > 0) {
            for (let filter of filtersChecked) {
                if (!mealPlans) continue;
                const mealPlanApplied = mealPlans[filter];
                if (typeof mealPlanApplied === "undefined" || !mealPlanApplied) continue;
                this.setMealPlanPrices(mealPlanApplied, group.id);

                groupTitle.html(mealPlanApplied.cholloMealPlanTitle);
                element.name = mealPlanApplied.cholloMealPlanTitle;
                groupDescription.html(mealPlanApplied.cholloMealPlanDescription);
                groupPrice.html(mealPlanApplied.cholloMealPlanPrice);

                if (mealPlanApplied.labelsInfo) {
                    schematicLabels.html('');
                    $.each(mealPlanApplied.labelsInfo, (index, label) => {
                        const schematicLabel = schematicLabelTemplate.clone(true);
                        const schematicLabelImg = schematicLabel.find('[data-entity="schematic-img"]');
                        const schematicLabelText = schematicLabel.find('[data-entity="schematic-text"]');
                        if (schematicLabelImg) {
                            schematicLabelImg.attr('src', label.img);
                        }
                        if (schematicLabelText) {
                            schematicLabelText.html(label.text);
                        }
                        if (schematicLabel) {
                            schematicLabels.append(schematicLabel);
                        }
                    });
                }


                if (additionalMealPlansContainer) {
                    const mealPlanAppliedBadges = $(additionalMealPlansContainer).find('[data-mealplan-id]');
                    $.each(mealPlanAppliedBadges, function (index, element) {
                        element.remove();
                    });

                    const mealPlanToPrint = [];
                    $.each(Object.values(mealPlans), function (index, mealPlan) {
                        if (mealPlan.mealPlanId === mealPlanApplied.mealPlanId) return;
                        mealPlanToPrint.push(mealPlan);
                    });

                    $.each(Object.values(mealPlanToPrint), function (index, mealPlan) {
                        const span = document.createElement('span');
                        span.setAttribute('data-mealplan-id', mealPlan.mealPlanId);
                        span.textContent = mealPlan.mealPlanText;
                        if (index < mealPlanToPrint.length - 1) {
                            span.textContent += ', ';
                        }
                        $(additionalMealPlansContainer).append(span);
                    });
                }
            }
        } else {
            if (!mealPlans) return;
            const mealPlanApplied = Object.values(mealPlans)[0];
            this.setMealPlanPrices(mealPlanApplied, group.id);

            groupTitle.html(mealPlanApplied.cholloMealPlanTitle);
            groupDescription.html(mealPlanApplied.cholloMealPlanDescription);
            groupPrice.html(mealPlanApplied.cholloMealPlanPrice);
            element.price = mealPlanApplied.cholloMealPlanPrice;
            element.name = mealPlanApplied.cholloMealPlanTitle;
            element.defaultMealPlan = mealPlanApplied.mealPlanId;

            if (mealPlanApplied.labelsInfo) {
                schematicLabels.html('');
                $.each(mealPlanApplied.labelsInfo, (index, label) => {
                    const schematicLabel = schematicLabelTemplate.clone(true);
                    const schematicLabelImg = schematicLabel.find('[data-entity="schematic-img"]');
                    const schematicLabelText = schematicLabel.find('[data-entity="schematic-text"]');
                    if (schematicLabelImg) {
                        schematicLabelImg.attr('src', label.img);
                    }
                    if (schematicLabelText) {
                        schematicLabelText.html(label.text);
                    }
                    if (schematicLabel) {
                        schematicLabels.append(schematicLabel);
                    }
                });
            }

            if (additionalMealPlansContainer) {
                const mealPlanAppliedBadges = $(additionalMealPlansContainer).find('[data-mealplan-id]');
                $.each(mealPlanAppliedBadges, function (index, element) {
                    element.remove();
                });

                const mealPlanToPrint = [];
                $.each(Object.values(mealPlans), function (index, mealPlan) {
                    if (mealPlan.mealPlanId === element.defaultMealPlan) return;
                    mealPlanToPrint.push(mealPlan);
                });

                $.each(Object.values(mealPlanToPrint), function (index, mealPlan) {
                    const span = document.createElement('span');
                    span.setAttribute('data-mealplan-id', mealPlan.mealPlanId);
                    span.textContent = mealPlan.mealPlanText;
                    if (index < mealPlanToPrint.length - 1) {
                        span.textContent += ', ';
                    }
                    $(additionalMealPlansContainer).append(span);
                });
            }
        }

        groupEntity.price = {
            'desc': groupPrice.text(), 'asc': groupPrice.text()
        };
    }

    _findGroupsIds(name, ids, orMode = true) {
        const idSet = new Set(ids);

        const selected = [];
        for (const [key, groupSet] of this.filterToGroupMap.entries()) {
            const [filterType, filterId] = key.split('-');
            if (filterType !== name) continue;
            if (idSet.has(Number(filterId))) {
                selected.push({
                    filterType,
                    filterId,
                    groupsIds: Array.from(groupSet)
                });
            }
        }

        if (selected.length === 0) return [];

        if (!orMode) {
            if (selected.length !== ids.length) return [];

            const intersection = selected
                .map(item => new Set(item.groupsIds))
                .reduce((acc, set) => {
                    return new Set([...acc].filter(x => set.has(x)));
                });

            return Array.from(intersection);
        }

        return selected.flatMap(item => item.groupsIds);
    }

    initializePriceFilterGraph() {
        if (!myApp.priceRangeGraph || myApp.priceRangeGraph.length === 0) return;
        const filterPriceGraph = document.getElementById('price-filter-graph');
        this.rangeGraph = null;
        if (filterPriceGraph && this.priceRange.size > 0) {
            this.rangeGraph = new RangeGraphInput(
                filterPriceGraph,
                this.doFilter.bind(this, true),
                '€'
            );
        }
    }

    setMealPlanPrices(mealPlan, groupId) {
        if (!myApp.priceRangeGraph || myApp.priceRangeGraph.length === 0) return;
        let price = Number(mealPlan.cholloMealPlanPrice);
        if (price < this.rangeGraph.sliderStart.min) {
            price = Number(this.rangeGraph.sliderStart.min);
        } else if (price > this.rangeGraph.sliderEnd.max) {
            price = Number(this.rangeGraph.sliderEnd.max);
        }
        const key = 'price-' + price;

        if (this.filterToGroupMap.has(key)) {
            this.filterToGroupMap.set(key, new Set([...this.filterToGroupMap.get(key), [groupId]]));
        } else {
            this.filterToGroupMap.set(key, new Set([groupId]));
        }

        if (this.priceRange.has(price)) {
            this.priceRange.set(price, new Set([...this.priceRange.get(price), [groupId]]));
        } else {
            this.priceRange.set(price, new Set([groupId]));
        }

        // Tiene que estar ordenado por las condiciones de setUserPriceFilter.
        if (this.priceRange.size > 0) {
            this.priceRange = new Map([...this.priceRange].sort((a, b) => a[0] - b[0]));
        }
    }

    updatePriceGraph(allGroups) {
        if (!myApp.priceRangeGraph || myApp.priceRangeGraph.length === 0) return;
        if (this.rangeGraph) {
            if (allGroups.length > 0) {
                allGroups = [...allGroups];

                const step = (this.priceRangeMax - this.priceRangeMin) / this.numBars;
                const bars = this.rangeGraph._calculateBars(
                    allGroups.map(el => Number(el.getAttribute('data-price'))).sort((a, b) => a - b),
                    step,
                    this.numBars,
                    this.priceRangeMin,
                    this.priceRangeMax
                );
                this.rangeGraph._generateGraphBars(bars, step, this.numBars);
                this.rangeGraph._fillSlider(this.rangeGraph.sliderEnd);
            }
        }
    }
    _filterResultsModuleVisibility(visible) {
        const filterResultsModule = document.getElementById('noFilterResults');
        if (filterResultsModule)  {
            filterResultsModule.style.display = visible ? '' : 'none';
            this.disableSorterIfNoResults(visible);
        }
    }

    disableSorterIfNoResults(visible) {
        const sorterSelector = document.querySelectorAll('[data-entity="sort-button"]');
        sorterSelector.forEach(el => {
            if (visible) {
                el.classList.add('disabled');
            } else {
                el.classList.remove('disabled');
            }
        });
    }

    createRemoveItem() {
        const removeItem = document.createElement('i');
        removeItem.classList.add('ci', 'ci-cross', 'ci-s-11');
        return removeItem;
    }

    showAppliedFilter(currentElement) {
        const filterName = currentElement.getAttribute('name');
        const filterParent = currentElement.closest('[data-entity=' + filterName + ']');
        const filterContainer = filterParent.cloneNode(true);

        const filterText = filterContainer.querySelector('[data-filter-text=' + filterName + ']');
        filterText.prepend(this.removeItem.cloneNode(true));

        const filterAction = filterContainer.querySelector('[data-action="filter"]');
        filterAction.setAttribute('data-entity', 'applied-filter');

        if (this.isMobileView) {
            this.filtersAppliedMobileContainer.append(filterContainer);
            this.filtersAppliedMobileModule.classList.remove('d-none');
            return;
        }
        this.filtersAppliedContainer.append(filterContainer);
        this.filtersAppliedModule.classList.remove('d-none');
    }

    removeAppliedFilter(currentElement) {
        const filterName = currentElement.getAttribute('name');

        let filterParent = null;
        if (this.isMobileView) {
            filterParent = this.filtersAppliedMobileModule.querySelector('[data-entity=' + filterName + ']');
        } else {
            filterParent = this.filtersAppliedModule.querySelector('[data-entity=' + filterName + ']');
        }

        if (!filterParent) return;
        filterParent.remove();

        if (this.isMobileView) {
            if (this.filtersAppliedMobileContainer.childElementCount === 0) {
                this.filtersAppliedMobileModule.classList.add('d-none');
            }
            return;
        }
        if (this.filtersAppliedContainer.childElementCount === 0) {
            this.filtersAppliedModule.classList.add('d-none');
        }
    }

    removeAllAppliedFilters() {
        if (this.isMobileView) {
            this.filtersAppliedMobileContainer.innerHTML = '';
            this.filtersAppliedMobileModule.classList.add('d-none');
            return;
        }
        this.filtersAppliedContainer.innerHTML = '';
        this.filtersAppliedModule.classList.add('d-none');
    }

    moveAppliedFilters() {
        if (this.isMobileView && this.filtersAppliedContainer.innerHTML !== '') {
            this.filtersAppliedMobileContainer.innerHTML = this.filtersAppliedContainer.innerHTML;
        }
        if (!this.isMobileView && this.filtersAppliedMobileContainer.innerHTML !== '') {
            this.filtersAppliedContainer.innerHTML = this.filtersAppliedMobileContainer.innerHTML;
        }

        if (this.isMobileView) {
            this.filtersAppliedMobileModule.classList.remove('d-none');
            this.filtersAppliedModule.classList.add('d-none');
        } else {
            this.filtersAppliedModule.classList.remove('d-none');
            this.filtersAppliedMobileModule.classList.add('d-none');
        }
    }
};
